import { createContext, ReactNode, useContext, useEffect } from 'react';
import { ProfileInfoResponse, useProfileInfo } from 'all-in-one-shared-api';
import { useKeycloak } from 'all-in-one-react-keycloak';
// import { useTranslation } from 'react-i18next';
import { useKeycloakReady } from 'hooks';

type ProfileInfoContextType = {
  state?: ProfileInfoResponse;
  isLoading?: boolean;
  mutate?: () => void;
  isValidating?: boolean;
};
export const ProfileInfoContext = createContext<ProfileInfoContextType>({});
export const ProfileInfoKey = 'getProfileInfo';

type ProfileInfoContextProviderProps = {
  children: ReactNode;
};

export const useProfileInfoContext = () => {
  return useContext(ProfileInfoContext);
};

export const ProfileInfoContextProvider = ({ children }: ProfileInfoContextProviderProps) => {
  const { keycloak } = useKeycloak();
  // const { i18n } = useTranslation();
  const { tokenParsed } = useKeycloakReady();
  const { shouldFetch, data, isLoading, mutate, isValidating } = useProfileInfo(ProfileInfoKey, keycloak?.token || '', {
    revalidateOnFocus: false,
  });

  useEffect(() => {
    if (tokenParsed?.ebClientKey) {
      if (keycloak.authenticated) shouldFetch(true);
    }
  }, [shouldFetch, keycloak.authenticated, tokenParsed]);

  // useEffect(() => {
  //   if (data) i18n.changeLanguage(data.localization);
  // }, [data, i18n]);

  return (
    <ProfileInfoContext.Provider value={{ state: data, isLoading, mutate, isValidating }}>
      {children}
    </ProfileInfoContext.Provider>
  );
};
